// self.DiagnosticsController      = new DiagnosticsController(_, core, params, helpers, )

var saveAs = require('file-saver').saveAs;

var saveLines = function(lines, fileName){

    saveAs(new Blob(_.map(lines, function(x){return x + "\r\n" } ), { type: 'text/plain;charset=utf-8'}), fileName || 'fusion-web-app-out.txt');

} 


console.error('saveAs', saveAs);


var DiagnosticsController = function (host, _, ko, core, helpers, console, events, callState) {

    var self                = this;
    var Promise             = core.Promise;
    var Repository          = core.Repository;
    var Models              = core.Models;
    var moment              = core.Moment;
    //var callStateService    = callState;
    var localStorageService = core.LocalStorageService;
    var guid                = core.Guid;
    var timestamp           = function () { return helpers.timeStamp(moment) }

    global.diagnostics = self;

    console.log('Diagnostics Controller', self);

    var red   = "color: red;   font-size:   medium",
        blue  = "color: blue;  font-size:   medium",
        green = "color: green; font-size:   medium",

        Red  = "color: red;  font-size:   large",
        Blue = "color: blue; font-size:   large",

        RED  = "color: red;  font-size: x-large",
        BLUE = "color: blue; font-size: x-large"

    diagnostics.hello = function(){

        console.log("%cHello!", RED);
    }

    diagnostics.tables = function(){

        console.log(core.Repository._allTables);
    }

    diagnostics.globalise = function(){
        var references = { ko: ko, helpers: helpers }
        _.assign(global, references);
        return references;
    }

    var withDB = function(operation){ return function(){

       var promises =  _.map(
           _.values(core.Repository._allTables)
           , function(table){ 
              return table.toArray(function(array){ return operation(table,array)} );
            }
           );
        
        return Promise.all(promises).then(function(array){ return _.orderBy(array,'name') });
    }}    

//  var dumpRow     = function(row){ return _.reduce(row, function(line, val, key) { return line +  (line? ', ':'') + (key + ':' + val) }, '')}
    var dumpRow     = function(obj){ 
        
        return (typeof obj === 'object') 
        ? _.reduce(obj, function(line, val, key) { return line +  (line? ', ':'') + dumpRow(val) }, '')
        : obj;
    }


    var tableCounts = withDB(function(table,array){ return { name: table.name, count:  array ? array.length : 0 }  });
    var tableDump   = withDB(function(table,array){ return _.map(array,function(row){ return { name: table.name, dump: dumpRow(row)  }  })  });


    diagnostics.tableCounts = function(filename){

        tableCounts().then(function(info){

           _.each(info, function(x){ console.log("%c%s %c%s", red, x.name, blue, x.count) });

           filename && saveLines(_.map(info,function(x){ return x.name + " , " + x.count }), filename);

        })
                      
    }

    diagnostics.tableDump = function(filename){

        tableDump().then(function(dumps){

           //_.each(_.flatten(dumps), function(x){ console.log("%c%s %c%s", red, x.name, blue, x.dump) });

           filename && saveLines(_.map(_.flatten(dumps),function(x){ return x.name + " , " + x.dump }), filename);

        })
                      
    }

    diagnostics.references = host;

   // diagnostics.callStateService = callStateService;

    diagnostics.deleteDB = function(){ return Promise.all(_.invokeMap([Repository, diagnostics.applicationStateController.__applicationStateDb] , 'delete' ) ) }
    //diagnostics.deleteDB = function(){ indexedDB.webkitGetDatabaseNames().onsuccess = function(sender){ _.forEach(sender.target.result, function(n){ console.error('Deleting',n); indexedDB.deleteDatabase(n) })} }

    diagnostics.repository = Repository;

    diagnostics.helpers = helpers;

    diagnostics.filters = function (noLog) {
        
        var filters = diagnostics.pictureFiltersViewModel.galleryFilters();

        noLog || _(filters).each(function (x) {
            
            console.log( 
            x.FieldName,
            x.RenderingType, 
            x.CascadeSetName, 
            x.Enabled() ? 'Enabled' : 'Disabled',
            x.FilterValue(),
            x.FilterValues()
        );

        })

        return filters;
    }


    Repository.on('changes', function (changes) {

            console.error('! ' + timestamp(), changes);

            // changes.forEach(function (change) {
            //     switch (change.type) {
            //         case 1: // CREATED 
            //             console.log('An object was created: ' + JSON.stringify(change.obj));
            //             break;
            //         case 2: // UPDATED 
            //             console.log('An object with key ' + change.key + ' was updated with modifications: ' + JSON.stringify(change.mods));
            //             break;
            //         case 3: // DELETED 
            //             console.log('An object was deleted: ' + JSON.stringify(change.oldObj));
            //             break;
            //         }
            // });


        });

}

module.exports = DiagnosticsController;